import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import * as actions from '../misc/actions';
import * as reducerActions from '../store/mainSlice'


export default function AppProvider(props) {
    const dispatch = useDispatch()
    const store = useSelector(({main}) => ({
        config: main.config,
    }))

    useEffect(() => {
        getAll()
    }, [])

    const getAll = () => {
        actions.getAll()
            .then(r => r.json())
            .then(res => {
                dispatch(reducerActions.setProducts(res))
                if(!store.config.product) {
                    dispatch(reducerActions.setConfig({
                        ...store.config,
                        product: {
                            label: res[0].title,
                            value: res[0].id,
                            img: res[0].gallery?.cover?.url,
                        },
                    }))
                }
            })
            .catch(err => {
                console.error('Something gone wrong!')
            })
    }

    return props.children
}
